define('app/editor/MonitorPage',['require','app/app','glu/layout','../visualizations/MonitorGridView','../visualizations/ErrorView','glu/dialog','./dialogs/SaveMonitorDialogView','app/app','glu/$','hbs!./MonitorPage.hbs'],function(require) {
	'use strict';

	var APP = require('app/app'),
		Layout = require('glu/layout'),
		MonitorGridView = require('../visualizations/MonitorGridView'),
		ErrorView = require('../visualizations/ErrorView'),
		dialog = require('glu/dialog'),
		SaveMonitorDialogView = require('./dialogs/SaveMonitorDialogView'),
		App = require('app/app'),
		$ = require('glu/$');

	var noDesc = '(No description)';

	return Layout.extend({

		className: 'page-monitor',

		dialog: dialog,

		ui: {
			$saveButton: '.monitor-save-button',
			$saveAsButton: '.monitor-save-as-button',
			$deleteButton: '.monitor-delete-button',
			$moreMenu: '.monitor-options-more',
			$monitorName: '.monitor-name',
			$errorMessage: '.report-alert'
		},

		events: {
			'click .toggle-monitor-definition-button': 'toggleMonitorDefinition',
			'click .monitor-rename': 'rename',
			'click .toggle-description': 'toggleDescription',
			'blur .description span': 'updateDescription',
			'focus .description span': 'clearDescription',
			'keydown .description span': 'descriptionKeyEvents',
			'click @ui.$saveButton': 'save',
			'click @ui.$saveAsButton': 'saveAs',
			'click @ui.$deleteButton': 'delete',
			'blur .monitor-name': 'updateMonitorName',
			'keydown .monitor-name': 'monitorNameKeyEvents'
		},

		template: require('hbs!./MonitorPage.hbs'),

		regions: {
			metrics: '.monitor-metrics',
			results: '.monitor-results',
			segments: '.monitor-segments'
		},

		initialize: function() {
			this.isRendered = false;
			var self = this;

			this.listenTo(this.model, 'gridRendered', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'monitor:change', function() {
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'saved', function() {
				self.model.clean();
				self.render();
				self.refreshClassesAndStates();
			});

			this.listenTo(this.model, 'change:name', this.renderName);

			this.listenTo(this.appBus, 'monitor:refresh', function() {
				self.refresh();
			});

			this.listenTo(this.appBus, 'monitor:viewport:change', function() {
				self.renderResults();
			});
		},

		serializeData: function() {
			return this;
		},

		refresh: function() {
			if (!this.isRendered) {
				return;
			}

			if (this.model.noMetrics() && this.model.noSegments()) {
				return;
			}

			// If ever the grid view is in a non runnable state, display an error message.
			// We should consider using this approach for all visualizations.
			if (this.model.getVisualization() === 'table' && !this.model.isRunnable()) {
				this.switchToVisualization('error');
			} else {
				this.switchToVisualization(this.model.getVisualization());
				this.model.run();
			}

			this.refreshClassesAndStates();
		},

		onRender: function() {
			this.isRendered = true;

			if (this.metricsView) {
				this.metrics.show(this.metricsView);
			}
			if (this.segmentsView) {
				this.segments.show(this.segmentsView);
			}

			var visualization = this.getVisualization(this.model.getVisualization());
			if (visualization) {
				this.results.show(visualization);
				this.refreshClassesAndStates();
			}
		},

		renderResults: function() {
			var visualization = this.getVisualization(this.model.getVisualization());
			if (visualization) {
				this.results.show(visualization);
				this.refreshClassesAndStates();
			}
		},

		onShow: function() {
			this.refresh();
		},

		getVisualization: function(visualization) {
			switch (visualization) {
				case 'table':
					return this.getGridVisualization();
				default:
					return this.getErrorVisualization();
			}
		},

		getGridVisualization: function() {
			return new MonitorGridView({
				model: this.model,
				id: 'monitor-results-grid'
			});
		},

		getErrorVisualization: function() {
			return new ErrorView({
				noMetrics: this.model.noMetrics(),
				noSegments: this.model.noSegments()
			});
		},

		name: function() {
			return this.model.get('name');
		},

		renderName: function() {
			this.$('.monitor-name').text(this.name());
		},

		toggleMonitorDefinition: function(evt) {
			evt.preventDefault();
			this.$el.toggleClass('is-monitor-definition-collapsed');
			this.render();
		},

		switchToVisualization: function(name) {
			this.results.currentView.close();
			this.results.show(this.getVisualization(name));
		},

		rerenderResults: function() {
			if (this.results.currentView) {
				this.results.currentView.render();
			}
		},

		clickAriaRadioButton: function(evt) {
			evt.preventDefault();
			this.model.setVisualization(this.$(evt.target).val());
			this.refreshClassesAndStates();
		},

		refreshClassesAndStates: function() {

			if (!this.isRendered) {
				return;
			}

			var self = this;
			self.$el.toggleClass('no-columns', self.model.noMetrics() && self.model.noSegments());

			if (self.model.noMetrics() && self.model.noSegments()) {
				self.ui.$errorMessage.hide();
			}

			// Toggle report action options
			if (!self.model.isNew()) {
				self.ui.$moreMenu.show();
				self.ui.$saveButton.show();
				self.ui.$saveButton.removeClass('menu-hidden');

				if (self.model.isOwner()) {
					if (self.model.isDirty() && self.model.isRunnable()) {
						self.ui.$saveButton.removeClass('disabled');
						self.ui.$saveButton.html('Save');
					} else if (self.model.isDirty() && !self.model.isRunnable()) {
						self.ui.$saveButton.addClass('disabled');
						self.ui.$saveButton.html('Save');
					} else {
						self.ui.$saveButton.addClass('disabled');
						self.ui.$saveButton.html('Saved');
					}
				} else {
					if (App.user.isInternalUser() && self.model.getIsPrivate()) {
						self.ui.$saveButton.html('Saved');
						self.ui.$saveButton.addClass('disabled');
					} else if (App.user.isInternalUser() && !self.model.getIsPrivate()) {
						self.ui.$saveButton.html('Saved');
						self.ui.$saveButton.addClass('disabled');
					} else if (self.model.isRunnable()) {
						self.ui.$saveButton.removeClass('disabled');
						self.ui.$saveButton.html('Save');
					} else {
						self.ui.$saveButton.addClass('disabled');
						self.ui.$saveButton.html('Save');
					}
				}
			} else {
				self.ui.$moreMenu.hide();
				self.ui.$saveButton.show();
				self.ui.$saveButton.addClass('menu-hidden');
				if (self.model.isDirty() && self.model.isRunnable()) {
					self.ui.$saveButton.removeClass('disabled');
					self.ui.$saveButton.html('Save');
				} else if (self.model.isDirty() && !self.model.isRunnable()) {
					self.ui.$saveButton.addClass('disabled');
					self.ui.$saveButton.html('Save');
				} else {
					self.ui.$saveButton.removeClass('disabled');
					self.ui.$saveButton.html('Save');
				}
			}


			if (!self.model.get('description') || self.model.get('description') === '' || self.model.get('description') === noDesc) {
				$('.description span').text(noDesc);
				$('.description span').addClass('no-desc');
			} else {
				$('.description span').text(self.model.get('description'));
				$('.description span').removeClass('no-desc');
			}
		},

		selectCurrentViewButton: function() {
			var $button = this.$el.find('.report-view-buttons [value="' + this.model.getVisualization() + '"]');
			$button.closest('[role=menubar]').find('[role=menuitemradio]').attr('aria-selected', false);
			$button.attr('aria-selected', true);
		},

		domainName: function() {
			return this.model.getDomainName();
		},

		monitorName: function() {
			return this.model.getName();
		},

		reportDescription: function() {
			return this.model.getDescription();
		},

		save: function(e) {
			var self = this;

			e.preventDefault();

			// Save is not allowed for internal users
			if (App.user.isInternalUser()) {
				return;
			}

			if ((this.model.isDirty() || self.model.isNew() || !self.model.isOwner()) && this.model.isRunnable()) {
				if (!this.model.isNew() && self.model.isOwner()) {
					this.model.set('saveInProgress', true, {
						silent: true
					});

					this.model.set('recentlyImported', undefined, {
						silent: true
					});

					if (this.model.getDescription() === noDesc) {
						this.model.set('description', '', {
							silent: true
						});
					}

					self.model.save().then(function() {
						self.model.set('saveInProgress', false, {
							silent: true
						});

						self.model.clean();

						self.refreshClassesAndStates();
					});
				} else {
					this.saveAs(e, false);
				}
			}
		},

		saveAs: function(e, setSaveAs) {
			var self = this;
			e.preventDefault();

			if (this.model.getDescription() === noDesc) {
				this.model.set('description', '', {
					silent: true
				});
			}

			var checkSaveAs = (setSaveAs === false) ? false : true;
			if (self.model.isRunnable()) {
				this.dialog.open(new SaveMonitorDialogView({
					model: self.model,
					className: 'modal-save-monitor',
					saveAs: checkSaveAs
				}));
			}
		},

		rename: function(e) {
			e.preventDefault();
			this.$el.find('.monitor-name').focus().select();
		},

		export: function(e) {
			var self = this,
				textFile;

			e.preventDefault();

			if (this.model.isRunnable() && (!this.$(e.target).parent().hasClass('disabled'))) {
				dialog.confirm('Exporting the report will save it to a downloadable text file, which can be sent to others to import. Are you sure you want to do this?', 'Export report', function(ok) {
					if (ok) {
						self.model.exportJson().then(function(res) {

							var reportName = self.model.getName();
							if (window.navigator.msSaveBlob) { // IE 10+
								textFile = new Blob([res], {
									type: 'text/plain;charset=utf-8;'
								});
								var url = navigator.msSaveBlob(textFile, reportName + '_export.txt');
								var tempLink = document.createElement('a');
								tempLink.href = url;
								tempLink.setAttribute('download', reportName + '_export.txt');
								tempLink.click();
							} else {
								textFile = 'data:text/plain;charset=utf-8,' + encodeURIComponent(res);
								var link = document.createElement('a');
								if (typeof link.download === 'string') {
									document.body.appendChild(link); // Firefox requires the link to be in the body
									link.download = reportName + '_export.txt';
									link.href = textFile;
									link.click();
									document.body.removeChild(link); // remove the link when done
								} else {
									location.replace(textFile);
								}
							}
						});
					}
				});
			}
		},

		delete: function(e) {
			var self = this;
			var cid = self.model.cid;

			e.preventDefault();

			var msg = 'Are you sure you want to delete this monitor?';
			this.dialog.confirm(msg, 'Delete Monitor', function(ok) {
				if (ok) {
					self.model.delete().then(function() {
						APP.openReports.remove(cid);
						self.navigateTo('/dashboard');
					});
				}
			}, function(data) {
				if (data && data.responseJSON) {
					if (data.responseJSON.errorCode !== 'UNKNOWN_EXCEPTION') {
						dialog.alert(data.responseJSON.errorMessage, 'An error occurred');
					} else {
						dialog.alert('An error occurred while processing your request. Please contact your local administrator.', 'An error occurred');
					}
				}
			});
		},

		isValid: function() {
			return this.model.isValid();
		},

		isOwner: function() {
			return this.model.isOwner();
		},

		getReportOwner: function() {
			return this.model.get('owner');
		},

		isPublic: function() {
			return this.model.get('isPrivate') === false;
		},

		isFollowing: function() {
			return this.model.get('isFollowing');
		},

		exportCsv: function(evt) {
			evt.preventDefault();
			var visType = this.model.getVisualization();
			if (this.model.isValid()) {
				if (visType === 'pivot-table') {
					var pivot = this.getPivotTableVisualization();
					var csvData = pivot.getCSV();
					var reportName = this.model.getName();
					if (window.navigator.msSaveBlob) { // IE 10+
						var csvURL = navigator.msSaveBlob(csvData, reportName + '_pivot.csv');
						var tempLink = document.createElement('a');
						tempLink.href = csvURL;
						tempLink.setAttribute('download', reportName + '_pivot.csv');
						tempLink.click();
					} else {
						var link = document.createElement('a');
						if (typeof link.download === 'string') {
							document.body.appendChild(link); // Firefox requires the link to be in the body
							link.download = reportName + '_pivot.csv';
							link.href = csvData;
							link.click();
							document.body.removeChild(link); // remove the link when done
						} else {
							location.replace(csvData);
						}
					}
				} else {
					this.model.exportCsv();
				}
			}
		},

		openAddColumnDialog: function(e) {
			e.preventDefault();

			// Use an existing event
			$('#select-columns-button').click();
		},

		updateMonitorName: function(e) {
			var name = !$(e.target).text() || $(e.target).text().trim() === '' ? 'Untitled Monitor' : $(e.target).text();
			this.model.set('name', name);
			$(e.target).text(name);
			this.refreshClassesAndStates();
		},

		monitorNameKeyEvents: function(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				this.ui.$monitorName.blur();
				this.refreshClassesAndStates();
			} else if (e.keyCode === 27) {
				e.preventDefault();
				$(e.target).text(this.model.get('name'));
				this.ui.$monitorName.blur();
			}
		},

		toggleDescription: function(e) {
			e.preventDefault();
			if (!this.model.get('description') || this.model.get('description') === '' || this.model.get('description') === noDesc) {
				$('.description span').text(noDesc);
				$('.description span').addClass('no-desc');
			}
			this.$el.find('.description').fadeToggle('fast');
		},

		updateDescription: function(e) {
			var description = !$(e.target).text() || $(e.target).text().trim() === '' ? noDesc : $(e.target).text();
			this.model.set('description', description);
			$(e.target).text(description);
			this.refreshClassesAndStates();
		},

		clearDescription: function(e) {
			if ($(e.target).text() === noDesc) {
				$(e.target).text('');
			}
		},

		descriptionKeyEvents: function(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				this.$el.find('.description span').blur();
			} else if (e.keyCode === 27) {
				e.preventDefault();
				$(e.target).text(this.model.get('description'));
				this.$el.find('.description span').blur();
			}
		},

		isRecentlyImported: function() {
			return this.model.get('recentlyImported');
		},

		showFullAccess: function() {
			return !this.isRecentlyImported() && this.isOwner();
		},

		hasDashboard: function() {
			return !!this.model.get('dashboardId');
		},

		getDashboardName: function() {
			var dashboardId = this.model.get('dashboardId');
			var dashboardArr = App.dashboards.filter(function(d) {
				return d.get('id') === dashboardId;
			});
			if (dashboardArr.length > 0) {
				var dashboard = dashboardArr[0];
				return dashboard.get('name') || dashboardId;
			} else {
				return 'Shared';
			}
		}
	});

});

